import React from "react";
import { Dropdown, Menu, MenuButton, MenuItem } from "@mui/joy";
import IconButtonCTA from "../../../common/IconButtonCTA";
import { colorTokens } from "../../../../styles/globalStyles";

type GoogleGroupsPickMenuProps = {
  items: string[];
  ariaLabel: string;
  onPick: (item: string) => void;
  getItemLabel?: (item: string) => string;
  children: React.ReactNode;
  disabled?: boolean;
};

export default function GoogleGroupsPickMenu(props: GoogleGroupsPickMenuProps) {
  const { items, ariaLabel, onPick, getItemLabel, children, disabled = false } = props;
  const isDisabled = disabled || items.length === 0;

  return (
    <Dropdown>
      <MenuButton
        slots={{ root: IconButtonCTA }}
        slotProps={{
          root: {
            "aria-label": ariaLabel,
            ctaVariant: "accent",
            disabled: isDisabled,
          },
        }}
      >
        {children}
      </MenuButton>
      <Menu
        placement="bottom-start"
        sx={{
          zIndex: 1300,
          bgcolor: colorTokens.bg.surfaceElevated,
          border: `1px solid ${colorTokens.border.default}`,
          boxShadow: `0 8px 24px ${colorTokens.bg.overlay}66`,
        }}
      >
        {items.map((item) => (
          <MenuItem
            key={item}
            onClick={() => onPick(item)}
            sx={{
              color: colorTokens.text.primary,
              "&:hover": { bgcolor: colorTokens.bg.hover },
            }}
          >
            {getItemLabel ? getItemLabel(item) : item}
          </MenuItem>
        ))}
      </Menu>
    </Dropdown>
  );
}
